import { useState } from "react";
import AnimatedCard from "./AnimatedCard";
import CaseStudiesSection from "./expertise/CaseStudiesSection";
import { caseStudies } from "@/data/caseStudies";
export const ExpertiseSection = () => {
  return <section id="expertise" className="section-padding relative px-6 overflow-hidden">
      {/* Background gradients */}
      <div className="absolute inset-0 bg-cosmic-indigo z-0"></div>
      <div className="absolute top-0 left-0 w-full h-48 bg-gradient-to-b from-[#0c1930] via-[#1a1b3a] to-transparent z-0"></div>
      <div className="absolute bottom-0 left-0 w-full h-48 bg-gradient-to-t from-[#0c1427] via-[#1a1b3a] to-transparent z-0"></div>
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-purple-500/20 rounded-full filter blur-[120px] opacity-30 z-0"></div>
      <div className="absolute bottom-1/3 right-1/4 w-80 h-80 bg-blue-500/20 rounded-full filter blur-[100px] opacity-30 z-0"></div>
      
      {/* Grid pattern overlay */}
      <div className="bg-grid-pattern absolute inset-0 opacity-20 z-0"></div>
      
      <div className="container mx-auto max-w-6xl relative z-10">
        <AnimatedCard animation="fade-in">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              <span className="text-gradient text-glow-blue">Our</span>{" "}
              <span className="text-white">Expertise & Experience</span>
            </h2>
            <p className="text-lg text-white/70 max-w-3xl mx-auto">See how innovative AI solutions have transformed legal operations for firms and corporate legal departments worldwide through our consulting work.</p>
          </div>
        </AnimatedCard>
        
        {/* Display case studies section directly without tabs */}
        <CaseStudiesSection caseStudies={caseStudies} />
      </div>
    </section>;
};
export default ExpertiseSection;